import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import qs from 'qs';
import { replace } from 'store/router/actions';

export const useCollectionsUuidMigration = (): void => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

    if (queryParams.collectionsUuid) {
      const { collectionsUuid, ...restParams } = queryParams;

      const updatedParams = {
        ...restParams,
        filterByCollection: collectionsUuid,
      };

      const newSearch = qs.stringify(updatedParams);
      const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;

      dispatch(replace(newUrl));
    }
  }, [location.search, location.pathname, dispatch]);
};
